import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TeamManagement } from "@/components/team_management/TeamManagement";

type UsersSettingsModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTalkToCs: () => void;
};

export function UsersSettingsModal({ open, onOpenChange, onTalkToCs }: UsersSettingsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-4xl" data-testid="users-settings-modal">
        <DialogHeader>
          <DialogTitle>Users</DialogTitle>
          <DialogDescription>Invite teammates and help them get access to Ordinal.</DialogDescription>
        </DialogHeader>
        <TeamManagement passwordReset={false} embedded teamManagementOnly />
        <div className="space-y-3 rounded-lg border p-4" data-testid="users-talk-to-cs">
          <p className="text-sm text-muted-foreground">
            Locked out? Talk to CS. Want SSO? Talk to CS.
          </p>
          <Button type="button" variant="outline" onClick={onTalkToCs}>
            Talk to CS
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
